<script lang="ts">
    import MainLayout from "../../#common/layout/Layout.svelte"
    import {Link} from 'svelte-routing'
    import {delay, navigate} from "src/components/cabinet/#common/helpers"
    import {doShow as showAlert} from "src/components/cabinet/#common/alert/store"
    import {getMembershipInfo, updateMembership} from 'src/components/cabinet/#services/memberships'

    export let id

    getMembershipInfo.reset()
    getMembershipInfo.send({data: {id: +id}})

    let membershipInfo
    $: if (!membershipInfo && $getMembershipInfo.hasValue) {
        membershipInfo = $getMembershipInfo.value && JSON.parse(JSON.stringify($getMembershipInfo.value))
    }

    let saved = false

    async function save() {
        saved = true
        if (membershipInfo.membership !== '' &&
            membershipInfo.isAvailable !== '' &&
            membershipInfo.maxCount !== '' &&
            membershipInfo.price !== '' &&
            membershipInfo.priceInLis !== '' &&
            membershipInfo.multiplier !== ''
        ) {
            try {
                await updateMembership.request({ data: membershipInfo })

                getMembershipInfo.reset()

                showAlert.set({
                    status: 'success',
                    text: 'Membership successfully updated!'
                })

                navigate("/memberships");
            } catch (err) {
                if (err.message) {
                    showAlert.set({
                        status: 'error',
                        text: err.message
                    })
                } else {
                    showAlert.set({
                        status: 'error',
                        text: 'An Error Occurred, Please Try Again Later'
                    })
                }
            }
        }
    }
</script>

<svelte:head>
    <title>Edit Membership</title>
</svelte:head>

<MainLayout title="Edit Membership">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <Link to="memberships" class="btn btn-primary mb-3">Back</Link>
                <div class="box">
                    {#if $getMembershipInfo.loading}
                        <tr>
                            <td colspan="2">Loading...</td>
                        </tr>
                    {:else if $getMembershipInfo.error || !$getMembershipInfo.hasValue }
                        <tr>
                            <td class="text-center" colspan="2">An error has occurred</td>
                        </tr>
                    {:else if $getMembershipInfo.value && membershipInfo}
                        <div class="form-group mb-3">
                            <div class="input-group">
                                <span class="input-group-text">Active?</span>
                                <div class="input-group-text">
                                    <input type="checkbox" class="form-check-input" bind:checked={membershipInfo.isAvailable}
                                       class:is-invalid={saved && membershipInfo.isAvailable === ''}>
                                </div>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <label>Name</label>
                            <input type="text" class="form-control field" bind:value={membershipInfo.membership}
                               class:is-invalid={saved && membershipInfo.membership === ''}>
                        </div>
                        <div class="form-group mb-3">
                            <label>Quantity</label>
                            <input type="text" class="form-control field" bind:value={membershipInfo.maxCount}
                               class:is-invalid={saved && membershipInfo.maxCount === ''}>
                        </div>
                        <div class="form-group mb-3">
                            <label>Multiplier</label>
                            <input type="text" class="form-control field" bind:value={membershipInfo.multiplier}
                               class:is-invalid={saved && membershipInfo.multiplier === ''}>
                        </div>
                        <div class="form-group mb-3">
                            <label>Price</label>
                            <div class="input-group">
                                <span class="input-group-text">$</span>
                                <input type="text" class="form-control field" bind:value={membershipInfo.price}
                                   class:is-invalid={saved && membershipInfo.price === ''}>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <label>Price</label>
                            <div class="input-group">
                                <span class="input-group-text">LIS</span>
                                <input type="text" class="form-control field" bind:value={membershipInfo.priceInLis}
                                   class:is-invalid={saved && membershipInfo.priceInLis === ''}>
                            </div>
                        </div>
                        <button class="btn btn-success" on:click={save}>Save</button>
                    {/if}
                </div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .box {
        max-width: 600px;
    }
</style>
